import { TintReturn } from "./TintReturn.js"

export function DecorClickHandler(RowArray,RowName,DrawArray,Scene)
{
    //console.log(RowArray);
    //console.log(RowName);
    //console.log(DrawArray);

    Scene.DrawState = true;
    if(Scene.HitBoxTree.depth != Scene.DepthList.HitBoxTree)
    {
        Scene.HitBoxTree.setDepth(Scene.DepthList.HitBoxTree);
    }
    switch(RowName)
    {
        case 'Row1': 
        case 'Row2':  
        case 'Row3':  
        case 'Row5':  
        case 'Row6': 
        case 'Row7':
            PrepareToDraw(Scene,RowArray); 
            break;
        case 'Row8': 
        case 'Row9': 
        case 'Row10':
        case 'Row11':
        case 'Row12':
        case 'Row13':
            MultiColorPrepareToDraw(Scene,RowArray);
            break;
        case 'Row4':
            //console.log("Peppermint");
            PeppermintPrepareToDraw(Scene,RowArray);
            break;
        default:
            break;
    }
}

function PrepareToDraw(Scene,RowArray)
{
    var DrawDetails = {Name: "Temp"};
    var DrawArray = [DrawDetails];
    Scene.DrawDistance = RowArray[1].x - RowArray[0].x;

    //console.log(Scene.DrawDistance)

    DrawArray[0].Name = RowArray[0].frame.name;    
    DrawArray[0].tint = TintReturn(RowArray[0].tintTopLeft);
    DrawArray[0].scale = RowArray[0].scale;

    if( RowArray[0].frame.name === RowArray[1].frame.name)
    {
        //console.log("if");

        DrawArray.push(DrawDetails);

        Scene.DrawArray = DrawArray;
    }

    else
    {
        //console.log("else");
        
        DrawArray[1] = {};

        DrawArray[1].Name = RowArray[1].frame.name;
        if(RowArray[1].isTinted)
        {
            DrawArray[1].tint = true;
        }
        else
        {
            DrawArray[1].tint = false;
        }
        DrawArray[1].scale = RowArray[1].scale;

        //console.log(DrawArray);

        Scene.DrawArray = DrawArray;
    }
}

function PeppermintPrepareToDraw(Scene,RowArray)
{
    RowArray[1] = RowArray[7];
    PrepareToDraw(Scene,RowArray)
}

function MultiColorPrepareToDraw(Scene,RowArray)
{
    var DrawDetails = {Name: "Temp"};
    var DrawArray = [DrawDetails];
    var HexString = "Test";
    Scene.DrawDistance = RowArray[1].x - RowArray[0].x;

    //console.log(Scene.DrawDistance)

    DrawArray[0].Name = RowArray[0].frame.name;    
    DrawArray[0].tint = TintReturn(RowArray[0].tintTopLeft);
    DrawArray[0].scale = RowArray[0].scale;
    DrawArray[0].hex = TintReturn(RowArray[0].tintTopLeft);

    HexString += TintReturn(RowArray[0].tintTopLeft);
    //console.log(HexString);

    for(let x = 1; x < RowArray.length;x++)
    {
        if(HexString.indexOf(TintReturn(RowArray[x].tintTopLeft)) === -1)
        {
            HexString += TintReturn(RowArray[x].tintTopLeft)
            DrawArray[x] = {};
            DrawArray[x].Name = RowArray[x].frame.name;    
            DrawArray[x].tint = TintReturn(RowArray[x].tintTopLeft);
            DrawArray[x].scale = RowArray[x].scale;
            DrawArray[x].hex = TintReturn(RowArray[x].tintTopLeft);
        }
        else
        {
            x = RowArray.length;
        }
    }
    //console.log(DrawArray);

    Scene.DrawArray = DrawArray;
}

export function PlaceDecor(Passed,Pointer,SelectionBackDrop)
{
    const Scene = Passed.scene;
    SelectionBackDrop.clear(true,true);
    Scene.DrawArray = {Name: "Temp"};
    Scene.InitialCheck = true;
    Scene.DrawState = false;
    const DepthList = Scene.DepthList;
 
    Scene.AudioChan.Chan1.play('pick_up_ornament');

    if(Scene.HitBoxTree.depth != DepthList.TreeDetail)
    {
        Scene.HitBoxTree.setDepth(DepthList.TreeDetail);
    }
    //console.log(Scene.IntitialCheck);
    Scene.input.setDragState(Scene.input.activePointer,0);

    let CopyOf;

    //console.log(Passed);
    CopyOf = Scene.addImage(Pointer.x,Pointer.y,Passed.frame.name);
    CopyOf.setTint(TintReturn(Passed.tintTopLeft));
    CopyOf.setInteractive();
    CopyOf.setDepth(DepthList.TreeItems);
    Scene.input.setDraggable(CopyOf);
    Scene.input._drag[0][0] = CopyOf;
    Scene.input._drag[1][0] = CopyOf;
    
    Scene.DragObject = CopyOf;

    Scene.input.setDragState(Pointer,4);
}
